import React, { useState, useEffect } from "react";
import axios from "axios";
import SidebarEtd from '../../../shared/components/SidebarEtd';
import { useNavigate } from "react-router-dom";
import HeaderEtd from '../../../shared/components/HeaderEtd';
import Pagination from "react-js-pagination";
import { getLoginInfo } from '../../../shared/utils/storage';
import ProgressBarComponent from '../../../shared/components/ProgressBar';
import ApplicationsTableComponent from "../../../shared/components/ApplicationsTable";
import AppManagementReusComponent from '../../../shared/hooks/useApplicationManagement';
import Lindo from '../../../app/guards/RouteGuard';

const ApprovalComponent = () => {
  const { isLoading, handleApplicationManagement } =
    AppManagementReusComponent();
  const [applications, setApplications] = useState([]);
  const [appStatistics, setAppStatistics] = useState({});
  const { mgambo } = Lindo();
  useEffect(() => {
    viewApplications();
  }, []);

  const viewApplications = async () => {
    mgambo("Mwamuzi");

    const payload = {
      ApplicationId: "",
      UserName: getLoginInfo()?.user?.Username,
      StageId: 520,
      Station: getLoginInfo()?.user?.StationID,
      Action: "Pool",
      AccessorId: getLoginInfo()?.user?.UserID,
    };
    const result = await handleApplicationManagement(
      payload,
      "application_management",
    );
    if (result?.code == 1) {
      setApplications(result?.data?.Applications);
      setAppStatistics(result?.data?.StatisticsApp[0]);
    } else {
      setApplications(null);
      setAppStatistics({});
      // const info = { type: "error", message: result.message };
      //   createNotification(info)();
    }
  };

  const handleUpdateApplicationTable = () => {
    viewApplications();
  };
  return (
    <>
      <HeaderEtd />
      <body className="">
        <div className="wrapper">
          <SidebarEtd />
          <div className="main-panel">
            <div className="content4">
              <div className="card-body">
                <h2 style={{ color: "#c2c2c2" }}>
                  <i>Approval</i>
                </h2>
              </div>
              <ProgressBarComponent appStatistics={appStatistics} />
              <ApplicationsTableComponent
                applicationsData={applications}
                updateApplicationTable={handleUpdateApplicationTable}
              />
            </div>
          </div>
        </div>
      </body>
    </>
  );
};

export default ApprovalComponent;
